import * as types from '../actions/types';

const initialState = {
    activebtn: {
        activebtn: "Tutorial",
        training: true,
        module: false
    }
}

export default function ActivebtnReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.TRAINING_BUTTON:
            return {
               
                activebtn:action.payload,
            } 
        default:
            return state
    }
}
